var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.creative._type
      ? _vm._.upperFirst(_vm.creative._type + 'Preview').replace('WithOutstream', '')
      : '',{tag:"component",attrs:{"creative":_vm.creative}})}
var staticRenderFns = []

export { render, staticRenderFns }